import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ToastModule} from 'primeng/toast';

import {DrawerHost} from '@shared/ui/drawer';
import {ModalHost} from '@shared/ui/modal';

@Component({
  selector: 'crm-root',
  imports: [RouterOutlet, ToastModule, DrawerHost, ModalHost],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  title = 'web';
}
